import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { general } from '../../../axiosConfig'

import { THEME_COLORS } from '../../../ThemeConfig.js'
import SearchButton from '../../includes/buttons/SearchButton.jsx'

const FaqsPage = () => {
  const [activeItems, setActiveItems] = useState([])
  const [searchItem, setSearchItem] = useState('')
  const [faqsResults, setFaqsResults] = useState([])
  const [searchExpand, setSearchExpand] = useState(false)
  const [statuses, setStatuses] = useState([])

  const faqs = [
    {
      id: 1,
      question: "What is MindMitra?",
      answer: "MindMitra is a healthcare company focused on mental well-being and fitness, offering services like psychometric tests, career counselling, and mental health support."
    },
    {
      id: 2,
      question: "Who is the target audience for MindMitra?",
      answer: "Students, working professionals, or individuals seeking mental health support"
    },
    {
      id: 3,
      question: "Where can I refer the privacy and confidentiality policy of MindMitra?",
      answer: "Please refer the Privacy Policy updated on the website for details."
    },
    {
      id: 4,
      question: "How do I sign up to be an expert on MindMitra?",
      answer: "Please sign up on the expert MindMitra website. Experts should provide complete and accurate information during signup. MindMitra verifies details before approving experts on the platform."
    },
    {
      id: 5,
      question: "What information do I need to provide during signup?",
      answer: "Experts must share name, contact details, Professional and academic qualifications etc as per the registration forms. Experts should upload relevant documents as well to complete the registration. KYC details and bank proof is required to verify the identity and to issue payments."
    },
    {
      id: 6,
      question: "How do I manage my availability for consultations?",
      answer: "• You can set up a default time schedule on the site to indicate your availability\n• Any changes to this schedule on specific days can be updated on the schedule section using update Slot option.\n• Notify MindMitra admin at least 48 hours before, if unable to attend a committed session. Any lapse to this clause will be treated seriously as it will be difficult find a substitute expert in the last moment."
    },
    {
      id: 7,
      question: "What are my responsibilities during a consultation?",
      answer: "• Accept a session invite received within 24 hours. Please note that the invite has been sent to you after matching your area of expertise, availability and language preferences.\n• Adhere to clinical standards, protocols, and regulations.\n• Provide case reports via the e-prescription module\n• Dress appropriately for video consultations.\n• Mark a follow up session if required or as requested by the patient."
    },
    {
      id: 8,
      question: "Are there restrictions on prescribing medications?",
      answer: "Yes, experts should not prescribe certain medications. Refer users for direct consultation if needed with the Permission of admin."
    },
    {
      id: 9,
      question: "How experts should handle patient privacy?",
      answer: "Experts should keep client's data or the information confidentially as per the Terms & Conditions and the applicable laws."
    },
    {
      id: 10,
      question: "What should I do in case of emergencies or specific incidents?",
      answer: "• Advise patients to seek in-person care in case of emergencies\n• Report physical abuse, sexual misconduct (especially minors), or self-harm to MindMitra within 5 hours via expertcare@mymindmitra.com"
    },
    {
      id: 11,
      question: "How the payments are handled?",
      answer: "• Payment slabs: Gold (75% expert, 25% MindMitra), Platinum (80% expert, 20% MindMitra)\n• All experts will be assigned with Gold slab on sign up (Minimum 5 years of experience)\n• Experts with 10 years of experience /PhD/RCI license will be upgraded to Platinum after 3 successful sessions\n• Mindmitra will release the payments once in a week (Sunday cycle)\n• Payments will be credited to the bank account shared during sign up\n• INR 200 will be kept on hold during the service of the expert as a caution deposit\n• Payments subject to tax deductions under Income Tax Act, 1961"
    },
    {
      id: 12,
      question: "Can MindMitra terminate my services?",
      answer: "Yes, the below reasons can cause termination of services.\n• Contravening laws or third-party reported violations\n• Violations of any Terms & Conditions of MindMitra\n• Repeated incidents of late entry to the sessions\n• Repeated cancellation of session without informing in advance as per the TAT (Min 48 hours prior)\n• Contacting patients outside Mindmitra by sharing contact details or taking direct sessions"
    }
  ]

  const handleOnClick = (id) => {
    if (activeItems.includes(id)) {
      setActiveItems(activeItems.filter((item) => item !== id))
    } else {
      setActiveItems([...activeItems, id])
    }
  }

  const handleSearch = (value) => {
    setSearchItem(value)
  }

  useEffect(() => {
    // Set the local FAQ data as statuses
    setStatuses(faqs)
  }, [])

  const renderStatuses = () => {
    return statuses.map((status) => (
      <Item
        key={status.id}
        className={activeItems.includes(status.id) && 'active'}
      >
        <QuestionWrapper>
          <Question>{status.question}</Question>
          <Arrow onClick={() => handleOnClick(status.id)}>
            {activeItems.includes(status.id) ? (
              <img
                src={require('../../../assets/image/faqs/up_arrow.svg').default}
                alt="up arrow"
              />
            ) : (
              <img
                src={
                  require('../../../assets/image/faqs/down_arrow.svg').default
                }
                alt="down arrow"
              />
            )}
          </Arrow>
        </QuestionWrapper>
        {activeItems.includes(status.id) && (
          <Answer>
            {status.answer.split('\n').map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </Answer>
        )}
      </Item>
    ))
  }

  useEffect(() => {
    if (searchItem) {
      const filteredFaqs = faqs.filter((faq) =>
        faq.question.toLowerCase().includes(searchItem.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchItem.toLowerCase())
      )
      setFaqsResults(filteredFaqs)
      setStatuses(filteredFaqs)
    } else {
      setFaqsResults(faqs)
      setStatuses(faqs)
    }
  }, [searchItem])

  return (
    <Main>
      <Top>
        <Left>FAQ'S</Left>
        <SearchButton searchItem={searchItem} handleSearch={handleSearch} />
      </Top>
      <Bottom>{renderStatuses()}</Bottom>
    </Main>
  )
}

export default FaqsPage

const Main = styled.div`
  width: 65%;
  margin: 32px auto;
  @media all and (max-width: 980px) {
    margin-bottom: 60px;
  }
`
const Top = styled.div`
  border-bottom: 1px solid ${THEME_COLORS.light_300};
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 20px;
`
const Left = styled.h3`
  font-weight: 700;
  font-size: 24px;
  color: ${THEME_COLORS.black};
`
const Bottom = styled.div`
  display: flex;
  flex-direction: column;
`
const Item = styled.div`
  background: ${THEME_COLORS.light_100};
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 10px;
  &.active {
    background: ${THEME_COLORS.light_200};
    padding: 12px 16px;
  }
`
const QuestionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Question = styled.h4`
  font-weight: 500;
  font-size: 14px;
  color: ${THEME_COLORS.black};
`
const Arrow = styled.div`
  margin-left: 10px;
  img {
    width: 100%;
  }
`
const Answer = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${THEME_COLORS.text_para};
  margin-top: 17px;
`
